import { supportedLocales } from '@webng-types/i18n';

function scoreLocale(locale: string, supportedLocale: string): number {
  if(locale === supportedLocale) {
    return 10;
  } else if(locale.startsWith(supportedLocale + "-")) {
    // Boundary-aware (RFC 4647 lookup): a bare startsWith would let "fil-ph"
    // match "fi", handing Filipino browsers a Finnish UI. The longest prefix wins,
    // so "de-ch-1996" lands on de-ch rather than de.
    return 5 + supportedLocale.length / 100;
  } else if(locale.split("-")[0] === supportedLocale.split("-")[0]) {
    return 4;
  } else if(supportedLocale === 'en') {
    return 1;
  } else {
    return 0
  }
}

// For code that branches on German outside i18next, where no fallback chain turns de-ch into de.
export function isGermanLanguage(locale?: string): boolean {
  return locale?.toLowerCase().split(/[-_]/)[0] === 'de'
}

export function findClosestLanguage(locale: string): string {
  locale = locale.toLocaleLowerCase()
  return supportedLocales.map(supportedLocale => ({supportedLocale, score: scoreLocale(locale, supportedLocale)}))
    .sort((a, b) => b.score - a.score)[0]
    .supportedLocale;
}